"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchSellerTransparencyDto = exports.UpdateSellerTransparencyDto = void 0;
const class_validator_1 = require("class-validator");
class UpdateSellerTransparencyDto {
    entityType;
    legalName;
    domain;
    detailsSubmitted;
    payoutsEnabled;
    syncedAt;
}
exports.UpdateSellerTransparencyDto = UpdateSellerTransparencyDto;
__decorate([
    (0, class_validator_1.IsEnum)(["individual", "organization"]),
    __metadata("design:type", String)
], UpdateSellerTransparencyDto.prototype, "entityType", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(300),
    __metadata("design:type", String)
], UpdateSellerTransparencyDto.prototype, "legalName", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(253),
    __metadata("design:type", String)
], UpdateSellerTransparencyDto.prototype, "domain", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], UpdateSellerTransparencyDto.prototype, "detailsSubmitted", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], UpdateSellerTransparencyDto.prototype, "payoutsEnabled", void 0);
__decorate([
    (0, class_validator_1.IsISO8601)(),
    __metadata("design:type", String)
], UpdateSellerTransparencyDto.prototype, "syncedAt", void 0);
class SearchSellerTransparencyDto {
    userIds;
}
exports.SearchSellerTransparencyDto = SearchSellerTransparencyDto;
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMaxSize)(10000),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], SearchSellerTransparencyDto.prototype, "userIds", void 0);
